// Imports
import React from "react"
import { FajnyIcon } from "fajny-react"

import { Container } from "./styles"

const CardIcon = ({ icon }) => {
    const { name, regular, solid, brand } = icon

    return (
        <Container to={`/icons/${name}`}>
            <FajnyIcon
                name={`${name}-${
                    regular ? "regular" : solid ? "solid" : brand ? "brand" : ""
                }`}
                size={32}
                color="primary"
            />

            {name}
        </Container>
    )
}

export default CardIcon
